// timeMeta — sdílené konstanty a formátovače time trackingu (6.8.2026).
// Vytaženo z pages/hr/TimeReport.jsx, ať je můžou používat i kalendář a
// statistika bez kruhového importu. TimeReport.jsx je dál re-exportuje,
// takže starší importy (Operations > Time tracking) fungují beze změny.

export const ACTIVITY_COLORS = {
  "Operations": "bg-plum-100 text-plum-700", "Marketing": "bg-pink-100 text-pink-700",
  "HR": "bg-blue-100 text-blue-700", "Clients Management": "bg-emerald-100 text-emerald-700",
  "Meeting": "bg-amber-100 text-amber-700", "Sales": "bg-rose-100 text-rose-700",
  "Tréninky": "bg-brand-100 text-brand-700", "Živé akce": "bg-orange-100 text-orange-700",
  "Education": "bg-sky-100 text-sky-700", "Plánování": "bg-teal-100 text-teal-700",
  "Administrativa": "bg-slate-200 text-slate-700",
  "Výživa a reporty": "bg-lime-100 text-lime-700", "Strategy": "bg-brand-100 text-brand-700",
};

// Plné barvy pro bloky v kalendáři a proužky ve statistice.
export const ACTIVITY_SOLID = {
  "Operations": "bg-plum-500", "Marketing": "bg-pink-500", "HR": "bg-blue-500",
  "Clients Management": "bg-emerald-500", "Meeting": "bg-amber-500", "Sales": "bg-rose-500",
  "Tréninky": "bg-brand-500", "Živé akce": "bg-orange-500", "Education": "bg-sky-500",
  "Plánování": "bg-teal-500", "Administrativa": "bg-slate-500",
  "Výživa a reporty": "bg-lime-500", "Strategy": "bg-brand-600",
};
export const activitySolid = (a) => ACTIVITY_SOLID[a] || "bg-slate-400";

// Jemné pozadí + levý pruh pro bloky v týdenní mřížce.
export const ACTIVITY_BLOCK = {
  "Operations": "bg-plum-50 border-plum-200 text-plum-800",
  "Marketing": "bg-pink-50 border-pink-200 text-pink-800",
  "HR": "bg-blue-50 border-blue-200 text-blue-800",
  "Clients Management": "bg-emerald-50 border-emerald-200 text-emerald-800",
  "Meeting": "bg-amber-50 border-amber-200 text-amber-800",
  "Sales": "bg-rose-50 border-rose-200 text-rose-800",
  "Tréninky": "bg-brand-50 border-brand-200 text-brand-800",
  "Živé akce": "bg-orange-50 border-orange-200 text-orange-800",
  "Education": "bg-sky-50 border-sky-200 text-sky-800",
  "Plánování": "bg-teal-50 border-teal-200 text-teal-800",
  "Administrativa": "bg-slate-100 border-slate-300 text-slate-700",
  "Výživa a reporty": "bg-lime-50 border-lime-200 text-lime-800",
  "Strategy": "bg-brand-50 border-brand-200 text-brand-800",
};
export const activityBlock = (a) => ACTIVITY_BLOCK[a] || "bg-slate-50 border-slate-200 text-slate-700";

export const QX_DESC = {
  Q1: "Urgentní + důležité", Q2: "Důležité, neurgentní",
  Q3: "Urgentní, nedůležité", Q4: "Neurgentní, nedůležité",
};
export const QX_SOLID = { Q1: "bg-rose-500", Q2: "bg-emerald-500", Q3: "bg-amber-400", Q4: "bg-slate-400" };

export const PUVOD_META = {
  live: { label: "Živě", cls: "bg-emerald-50 text-emerald-700 border-emerald-200", title: "Měřeno stopkami od začátku" },
  zpetny_start: { label: "Zpětný start", cls: "bg-amber-50 text-amber-700 border-amber-200", title: "Stopky se zpětně vloženým začátkem" },
  rucni: { label: "Vloženo zpětně", cls: "bg-rose-50 text-rose-700 border-rose-200", title: "Celý záznam doplněn ručně" },
  // 3.9.2026: blok, který zapsal owner (společná akce s klienty a podobně).
  owner: { label: "Zadal owner", cls: "bg-brand-50 text-brand-700 border-brand-200", title: "Časový blok zapsal owner, nemusíš si ho měřit" },
};

export const DAY_NAMES = ["Po", "Út", "St", "Čt", "Pá", "So", "Ne"];
export const MONTH_NAMES = ["leden", "únor", "březen", "duben", "květen", "červen", "červenec", "srpen", "září", "říjen", "listopad", "prosinec"];

export function fmtDur(sec) {
  sec = Math.max(0, Math.round(sec));
  const h = Math.floor(sec / 3600), m = Math.floor((sec % 3600) / 60), s = sec % 60;
  return h > 0 ? `${h}:${String(m).padStart(2, "0")}:${String(s).padStart(2, "0")}` : `${m}:${String(s).padStart(2, "0")}`;
}
export function fmtHours(sec) { return `${Math.round((sec / 3600) * 10) / 10} h`; }
// "4 h 35 min" — čitelnější pro součty v kalendáři a statistice.
export function fmtHm(sec) {
  const m = Math.max(0, Math.round((sec || 0) / 60));
  const h = Math.floor(m / 60);
  return h > 0 ? `${h} h ${String(m % 60).padStart(2, "0")} min` : `${m} min`;
}
export function fmtDayCz(iso) { const p = String(iso).slice(0, 10).split("-"); return p.length === 3 ? `${Number(p[2])}. ${Number(p[1])}.` : iso; }
export function fmtDayFull(iso) {
  const p = String(iso).slice(0, 10).split("-");
  if (p.length !== 3) return iso;
  return `${Number(p[2])}. ${Number(p[1])}. ${p[0]}`;
}
// Po=0 … Ne=6
export function dowIdx(iso) { const d = new Date(String(iso).slice(0, 10) + "T00:00:00").getDay(); return d === 0 ? 6 : d - 1; }
export function addDaysIso(iso, n) {
  const d = new Date(String(iso).slice(0, 10) + "T12:00:00");
  d.setDate(d.getDate() + n);
  return d.toISOString().slice(0, 10);
}
export function mondayOf(iso) { return addDaysIso(iso, -dowIdx(iso)); }
export function minutesOf(hhmm) {
  const m = /^(\d{1,2}):(\d{2})$/.exec(String(hhmm || "").trim());
  return m ? Number(m[1]) * 60 + Number(m[2]) : null;
}
